module.exports = __webpack_public_path__ + "img/NewCarIcon.dccf00d6.svg";